var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.program.id)?_c('div',[_c('ProgramInfo',{attrs:{"program":_vm.program}}),_c('ProgramDestinations',{attrs:{"program":_vm.program}}),_c('ProgramLives',{attrs:{"program":_vm.program}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }